import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiPermissions, apiRolesList, apiRolesView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/roles/getData', async datas => {
    const { data } = await apiRolesList(datas)
    return data
})

export const getView = createAsyncThunk('admin/roles/getView', async id => {
    if (!id) return viewData
    const { data } = await apiRolesView(id)
    return data
})

export const getPermissions = createAsyncThunk('admin/roles/getPermissions', async () => {
    const { data } = await apiPermissions()
    return data
})

const viewData = {
    name: '',
    permissions: [],
}

export const rolesSlice = createSlice({
    name: 'admin/roles',
    initialState: {
        loading: true,
        view: viewData,
        permissions: [],
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
            .addCase(getPermissions.pending, state => {
                state.permissions = []
            })
            .addCase(getPermissions.fulfilled, (state, { payload }) => {
                state.permissions = payload
            })
    },
})

export const { setData, setTableData } = rolesSlice.actions

export default rolesSlice.reducer
